import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 9,
  class: "flex-1 min-w-max mb-4"
}
const _hoisted_2 = {
  key: 10,
  class: "flex-1 min-w-max mb-4"
}

import type { Ref } from 'vue';
import { onBeforeMount, ref, computed } from 'vue';
import StudentTable from './components/StudentTable.vue';
import BillingAdminTable from './components/BillingAdminTable.vue';
import ClinicianTable from './components/ClinicianTable.vue';
import FacilitatorsTable from './components/FacilitatorsTable.vue';
import CaseManagersTable from './components/CaseManagersTable.vue';
import SchoolAdminsTable from './components/SchoolAdminsTable.vue';
import Disciplines from './components/Disciplines.vue';
import Services from './components/Services.vue';
import SubOrganizations from './components/OrganizationsConnectionsSubOrganizationTable.vue';
import ParentsTable from './components/ParentsTable.vue';
import Buildings from './components/Buildings/Buildings.vue';
import Grades from './components/Grades/Grades.vue';
import { can, useRouting, usePersonTypes } from '@/composables';
import { PERMISSIONS, PEOPLE_TYPES } from '@/enum';
import { useAuthStore, PersonStores } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'Connections',
  setup(__props) {

const $routing = useRouting();
const organizationId: Ref<number> = ref(0);
const profileStore = PersonStores.useUserProfileStore();

onBeforeMount(() => {
  organizationId.value = parseInt($routing.route.params.id as string);
});

const isClinician = computed(() =>
  usePersonTypes.isClinician(profileStore.person?.people_type?.acronym as PEOPLE_TYPES),
);

const isStudent = computed(() => usePersonTypes.isStudent(profileStore.person?.people_type?.acronym as PEOPLE_TYPES));

//TODO: add once backend --> can([PERMISSIONS.ORGANIZATION_BILLING_ADMIN_INDEX]) &&
const canSeeBillingAdminTable = computed(() => useAuthStore().currentInstanceIsMasterTenant);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_STUDENTS_INDEX]))
      ? (_openBlock(), _createBlock(StudentTable, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_CLINICIANS_INDEX, _unref(PERMISSIONS).ORGANIZATION_CLINICIANS_INDEX_SELF]))
      ? (_openBlock(), _createBlock(ClinicianTable, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_PARENTS_INDEX]))
      ? (_openBlock(), _createBlock(ParentsTable, {
          key: 2,
          "organization-id": organizationId.value
        }, null, 8, ["organization-id"]))
      : _createCommentVNode("", true),
    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_FACILITATORS_INDEX]))
      ? (_openBlock(), _createBlock(FacilitatorsTable, { key: 3 }))
      : _createCommentVNode("", true),
    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_SCHOOL_ADMIN_INDEX]))
      ? (_openBlock(), _createBlock(SchoolAdminsTable, { key: 4 }))
      : _createCommentVNode("", true),
    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_CASE_MANAGER_INDEX]))
      ? (_openBlock(), _createBlock(CaseManagersTable, { key: 5 }))
      : _createCommentVNode("", true),
    (canSeeBillingAdminTable.value)
      ? (_openBlock(), _createBlock(BillingAdminTable, { key: 6 }))
      : _createCommentVNode("", true),
    _createVNode(Buildings, { "organization-id": organizationId.value }, null, 8, ["organization-id"]),
    (isClinician.value || isStudent.value)
      ? (_openBlock(), _createBlock(Grades, {
          key: 7,
          "organization-id": organizationId.value
        }, null, 8, ["organization-id"]))
      : _createCommentVNode("", true),
    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_SUB_ORGANIZATIONS]))
      ? (_openBlock(), _createBlock(SubOrganizations, { key: 8 }))
      : _createCommentVNode("", true),
    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_DISCIPLINES_INDEX]))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Disciplines, { "organization-id": organizationId.value }, null, 8, ["organization-id"])
        ]))
      : _createCommentVNode("", true),
    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_SERVICES_INDEX]))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Services, {
            "organization-id": organizationId.value,
            header: "Event Types"
          }, null, 8, ["organization-id"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})